import React from "react";
import "./Terms.css";

export default function Terms() {
  return (
    <div className="Terms">
      <p dir="ltr">私隱保護聲明</p>
      <p dir="ltr">
        X的士
        深信保護您的私隱和給予您最好的服務同樣重要，因此我們決意遵守於香港有關個人資料保護法規並訂下此《私隱保護聲明》。在您進入及使用本手機應用程式的同時，您將被視為完全同意並願意無條件遵守以下的《私隱保護聲明》。
      </p>
      <br />
      <p dir="ltr">蒐集個人資料</p>
      <p dir="ltr">
        若非得到您本人的同意或受法律強制所規範之情況下，X的士
        絕不會出售、散佈或出讓您任何的個人資料予第三者。任何您自願提供的資料均只會作為您和
        X的士 之間的商業用途。
      </p>
      <br />
      <p dir="ltr">確保資料準確</p>
      <p dir="ltr">
        當您註冊為 X的士 的會員或使用 X的士
        的服務時，我們會請您提供予我們您的個人資料，請務必確保您所提供的資料均屬實，並在需要更改該等資料的時候親自聯絡我們。
      </p>
      <br />
      <p dir="ltr">個人資料的使用</p>
      <p dir="ltr">
        依上述所說，您提供予 X的士
        的個人資料只會用作商業用途，例如：為您提供服務和產品、給予合適的咨詢服務、助我們更了解您的需要及興趣，和你建立更好的關係、或提供產品及服務優惠。
      </p>
      <br />
      <p dir="ltr">使用及取消帳戶</p>
      <p dir="ltr">
        不管在任何情況下，請保密您的帳號及密碼，以免被人盜用，你亦必須為任何以您的帳戶所進行的在線活動而負責。如您疏忽而引致任何損失或破壞，本公司概不負責。若您想要取消的帳戶，請親函到
        hello@tooltips.tech 。
      </p>
      <br />
      <p dir="ltr">更改聲明明細</p>
      <p dir="ltr">
        X的士
        隨時有權對此《私隱保護聲明》作出任何更改、修訂或更新，而無需另行通知。我們會在聲明頁面底部列明更新日期，並建議您多留意聲明更新的內容。
      </p>
      <br />
      <p dir="ltr">生效日期</p>
      <p dir="ltr">此《私隱保護聲明》的生效日期為：二零二零年七月二十一日</p>
      <br />
      <p dir="ltr">PRIVACY POLICY STATEMENT</p>
      <p dir="ltr">
        X TAXI believes that keeping your privacy is as important as providing
        you the best service, so we are determined to comply with the Hong Kong
        SAR Personal Data (Privacy) Ordinance and make the following Privacy
        Policy Statement. By accessing and browsing the Site, you accept,
        without limitation or qualification, the Privacy Policy below.
      </p>
      <br />
      <p dir="ltr">PERSONAL DATA COLLECTION STATEMENT</p>
      <p dir="ltr">
        X TAXI will collect and use your personal data information in
        accordance with our company’s Privacy Policy and Personal Data
        Collection Statement which you have read and agreed before your
        submission of personal data to our company. Any information that you
        voluntarily provide is for our business, marketing, direct marketing,
        communication, servicing and related purposes.
      </p>
      <br />
      <p dir="ltr">ACCURACY OF INFORMATION</p>
      <p dir="ltr">
        During your registration or use of our services, you may require
        providing us with your own information. You are responsible for
        providing accurate information to us and will notify us if you wish to
        make any correction of data.
      </p>
      <br />
      <p dir="ltr">USE OF PERSONAL INFORMATION</p>
      <p dir="ltr">
        As mentioned above, X TAXI uses your personal information for the
        purposes of business, marketing, direct marketing, communication,
        servicing and related purposes, for instance, to provide services and
        products, offer appropriate customer service, better understand your
        needs and interests, enhance our relationship with you, or make
        promotional offers by our company.
      </p>
      <br />
      <p dir="ltr">USE OF AND TERMINATION OF ACCOUNT</p>
      <p dir="ltr">
        You are at all times responsible for maintaining the confidentiality of
        the username and password and to prevent any unauthorized success. Also,
        you are responsible for any use under your active account. In no event
        will we be liable for any loss or damage arising from your lack of
        ability to protect your own account. If you wish to cancel your account,
        cancellation requests must be sent via email hello@tooltips.tech.
      </p>
      <br />
      <p dir="ltr">PRIVACY POLICY CHANGES</p>
      <p dir="ltr">
        We reserve the right, at all times, to modify, alter, or update this
        Privacy Policy Statement without prior notice, and you agree to be bound
        by such modifications, alterations, or updates once they are posted on
        this Site. The revised Privacy Policy Statement will be dated on this
        website for your reference and since you are bound by these terms, we
        encourage you to check it periodically to review the most updated terms.
        Any rights not expressly granted herein are reserved by our company.
      </p>
      <br />
      <p dir="ltr">EFFECTIVE DATE</p>
      <p dir="ltr">
        This Disclaimer / Privacy Policy / Terms of Service is effective as of
        Jul 21, 2020.
      </p>
      <div>
        <br />
      </div>
    </div>
  );
}
